export default __webpack_public_path__ + "static/media/business-ahs-icon-1.c4c84f02.png";